import React from 'react';

const Footer = () => {
  const footerLinks = {
    productos: [
      { name: 'CRM', href: '/crm' },
      { name: 'Ventas', href: '/ventas' },
      { name: 'Inventario', href: '/inventario' },
      { name: 'Contabilidad', href: '/contabilidad' },
      { name: 'RRHH', href: '/rrhh' },
      { name: 'Proyectos', href: '/proyectos' },
      { name: 'Soporte', href: '/helpdesk' },
      { name: 'SurveyHub', href: '/surveyhub' },
      { name: 'Control de Asistencia', href: '/control-asistencia' },
      { name: 'SpacesHub', href: '/spaceshub' },
      { name: 'Logística', href: '/logistica' },
      { name: 'Facturación', href: '/facturacion' },
      { name: 'Control de Acceso', href: '/control-acceso' },
      { name: 'Controladoras SKO', href: '/sko' },
      { name: 'MeetingRoom', href: '/meetingroom' },
      { name: 'App Personalizada', href: '/app-personalizada' },
      { name: 'Cloudbase Endpoint', href: '/cloudbase-endpoint' }
    ],
    soluciones: [
      { name: 'Coworks', href: '/coworks' },
      { name: 'Pymes y Empresas', href: '/empresas' },
      { name: 'Inmobiliarias', href: '/inmobiliarias' },
      { name: 'Multifamilias', href: '/multifamily' },
      { name: 'Gimnasios', href: '#' }
    ],
    recursos: [
      { name: 'Documentación', href: '#' },
      { name: 'Blog', href: '#' },
      { name: 'Casos de Éxito', href: '#' },
      { name: 'Soporte', href: '/soporte' }
    ],
    empresa: [
      { name: 'Nosotros', href: '/nosotros' },
      { name: 'Carreras', href: '#' },
      { name: 'Contacto', href: '#' },
      { name: 'Partners', href: '#' }
    ]
  };

  return (
    <footer className="bg-black text-gray-400">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_smart-workspaces/artifacts/joupqq6v_logo_blue_horizontal.png" 
              alt="Cloudbase" 
              className="mb-6 brightness-0 invert"
              style={{ height: '5rem' }}
            />
            <p className="text-sm mb-4 leading-relaxed">
              Plataforma integrada de gestión empresarial para Latinoamérica y España.
            </p>
            <p className="text-xs text-gray-500 leading-relaxed">
              Con clientes en <span className="text-gray-300">Chile · México · Argentina · Brasil · Estados Unidos · España</span>
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Productos</h3>
            <ul className="space-y-3">
              {footerLinks.productos.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Soluciones</h3>
            <ul className="space-y-3">
              {footerLinks.soluciones.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Recursos</h3>
            <ul className="space-y-3">
              {footerLinks.recursos.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm">
            © 2025 Cloudbase. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="/privacidad" className="hover:text-white transition-colors">Privacidad</a>
            <a href="#" className="hover:text-white transition-colors">Términos</a>
            <a href="#" className="hover:text-white transition-colors">Seguridad</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;